import React, { useState } from 'react';

import { ISpecOfferTerm } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import * as Accordion from '@r1-frontend/ui-react/components/accordions/Accordion';
import { TTheme } from '@r1-frontend/ui-react/components/accordions/Accordion/themes';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { FullWidthListContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const accordionTheme: TTheme = {
    border: COLORS.BgSurface,
    background: COLORS.BgSurface,
    radius: BorderRadius.InnerBlockRadius,
    mobileRadius: BorderRadius.InnerBlockRadius,
    padding: '12px 24px',
    mobilePadding: '12px 24px',
    color: COLORS.TextPrimary,

    buttonType: 'ghost',
    buttonTypeIsOpen: 'ghost',

    borderIcon: COLORS.transparent,
    borderIconIsOpen: COLORS.transparent,
};

interface IProps {
    terms?: ISpecOfferTerm,
    onShowTerms?: () => void,
}

const PromotionTerms = ({ terms, onShowTerms }: IProps): JSX.Element | null => {
    const [isShowTerms, setIsShowTerms] = useState(false);

    if (!terms) {
        return null;
    }

    const toggleIsShowTerms = () => {
        if (!isShowTerms && onShowTerms) {
            onShowTerms();
        }

        setIsShowTerms(prev => !prev);
    };

    return (
        <Accordion.Wrapper theme={accordionTheme}>
            <Accordion.Header
                isOpen={isShowTerms}
                colors={accordionTheme}
                onOpen={toggleIsShowTerms}
            >
                <H4 $withIndent={false} $smaller>{terms.title}</H4>
            </Accordion.Header>
            <Accordion.Body isOpen={isShowTerms} withDividingBorder={false}>
                <IndentContainer $united={[12, 0]}>
                    <FullWidthListContainer $direction={'column'} $size={4}>
                        <Paragraph4 as={'div'} $color={COLORS.TextInfo} dangerouslySetInnerHTML={{ __html: terms.description }}/>
                        {terms.pdf && (
                            <a href={terms.pdf} target='_blank' rel='noreferrer'>{terms.pdfTitle}</a>
                        )}
                    </FullWidthListContainer>
                </IndentContainer>
            </Accordion.Body>
        </Accordion.Wrapper>
    );
};

export default PromotionTerms;
